import type {
  SettlementManualTicketSaleInput as GQLInput,
  SettlementManualTicketSale as GQLItem,
} from '../../../generated/api.graphql';
import { take } from '../../../util';

/** A manually entered ticket-sales line as the server sends it. */
export type ManualTicketSale = {
  id: number;
  description?: string | null;
  price?: number | null;
  ticketsSold?: number | null;
};

/** A line on the way back. The id is optional: `SettlementConfig.vue` appends rows without one. */
export type ManualTicketSaleInput = {
  id?: number | null;
  description?: string | null;
  price?: number | null;
  ticketsSold?: number | null;
  _destroy?: boolean | null;
};

export const fromGql = (item: GQLItem): ManualTicketSale => ({
  id: item.id,
  description: item.description ?? null,
  price: item.price ?? null,
  ticketsSold: item.ticketsSold ?? null,
});

const GQL_FIELDS = ['id', '_destroy', 'description', 'price', 'ticketsSold'] as const;

export const toGqlInput = (sale: ManualTicketSaleInput): GQLInput =>
  take<GQLInput, ManualTicketSaleInput>(sale, ...GQL_FIELDS);
